<template>
<div class="chapter">
<div class="inner_page">
<div class="abt">
<p class="nonindent"><strong>‘You often boast to me that you have the king’s ear and often have fun with him, freely and according to your whims. This is like having fun with tamed lions – often it is harmless, but just as often there is fear of harm. Often he roars in rage for no known reason, and suddenly the fun becomes fatal.’</strong></p>
<p class="right">Thomas More</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abt.vue?5d0dc62c